import type { ApolloError } from '@apollo/client';

export enum SubmitStatus {
  INITIAL = 'initial',
  VALIDATING_SERVER_SIDE = 'validating-server-side',
  VALIDATING_CLIENT_SIDE = 'validating-client-side',
  SUBMITTING = 'submitting',
  COMPLETED = 'completed',
  ERROR = 'error',
}

export enum SubmitEventType {
  START_SUBMIT_VALIDATION = 'ordering.startSubmitValidation',
  VALIDATE_SERVER_SIDE_DONE = 'ordering.validateServerSideDone',
  VALIDATE_CLIENT_SIDE_DONE = 'ordering.validateClientSideDone',
  SUBMIT_DONE = 'ordering.submitDone',
  CLEAR_ERROR = 'ordering.clearError',
}

export type SubmitReducerState = {
  status: SubmitStatus;
  error: string | ApolloError | null
};

type StartSubmitValidation = { type: SubmitEventType.START_SUBMIT_VALIDATION }
type ValidateServerSideDone = { type: SubmitEventType.VALIDATE_SERVER_SIDE_DONE, context: { error: SubmitReducerState['error'] } }
type ValidateClientSideDone = { type: SubmitEventType.VALIDATE_CLIENT_SIDE_DONE, context: { error: SubmitReducerState['error'] } }
type SubmitDone = { type: SubmitEventType.SUBMIT_DONE, context: { error: SubmitReducerState['error'] } }
type ClearError = { type: SubmitEventType.CLEAR_ERROR }

export type SubmitReducerEvent = StartSubmitValidation | ValidateServerSideDone | ValidateClientSideDone | SubmitDone | ClearError;
